import { cn } from '@/lib/utils';

import { G2Badge } from '@/integrations/g2';
import { ProxywayBadge } from '@/integrations/proxyway';
import { TrustpilotBadge } from '@/integrations/trustpilot';

import { Divider } from '@/decodo/components/atoms/Divider';

export function ReputationBadges({
  classNames,
}: {
  classNames?: { root?: string };
}) {
  return (
    <div className={cn('flex gap-3', classNames?.root)}>
      <div>
        <TrustpilotBadge />
      </div>
      <div>
        <Divider
          showOnDark
          alignment='vertical'
          classNames={{ root: 'border-gray-200' }}
        />
      </div>
      <div>
        <G2Badge />
      </div>
      <div>
        <Divider
          showOnDark
          alignment='vertical'
          classNames={{ root: 'border-gray-200' }}
        />
      </div>
      <div>
        <ProxywayBadge />
      </div>
    </div>
  );
}
